module.exports = __webpack_public_path__ + "static/media/signet.271fba06.png";